import React, { useEffect } from 'react'
import { formatMoney } from '../../../../../../helpers/DateFormat';
interface BillProps {
    values: any;
}
const BillListView: React.FC<BillProps> = (props) => {
    return (
        <div className='p-2'>
            <div className='border border-green rounded-md p-2'>
                <div className="relative overflow-x-auto">
                    <ul className='text-[12px] space-y-1'>
                        <li><span className='font-semibold'>Product Name:</span><span className='font-light italic text-green-600'> {props.values.pro_name}</span></li>
                        <li><span className='font-semibold'>Sales Qty </span>: <span className='font-light italic text-green-600'>{props?.values?.sales_qty}</span></li>
                        <li><span className='font-semibold'>VAT </span>: <span className='font-light italic text-green-600'>{props.values?.vat_amt}</span></li>
                        <li><span className='font-semibold'>Dis Amt </span>: <span className='font-light italic text-green-600'>{formatMoney(props.values?.dis_amt || "0")}</span></li>
                        <li><span className='font-semibold'>Dis % </span>: <span className='font-light italic text-green-600'>{props.values?.dis_per}</span></li>
                        <li className='py-1 border-b border-dotted'></li>
                        <li><span className='font-semibold'>Total Amount</span>: <span className='font-light italic text-green-600'>{formatMoney(props.values?.sel_tot_amt || "0")}</span></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default BillListView